import { render, staticRenderFns } from "./IconTeamAlignment.vue?vue&type=template&id=31336106"
import script from "./IconTeamAlignment.vue?vue&type=script&lang=js"
export * from "./IconTeamAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports